import {ActionHandlerBase} from "../action-handler-base";
import {
    AppIdentifiers,
    IPerformActionPayloadBase,
    ProductPackageToID
} from "@sparkware/uc-sdk-core";
import {
    getCasinofiedCommonAppContextParams,
    getCasinofiedDeviceInfo,
    getCasinofiedGeoInfoParams
} from "../../casinofied-helper-functions";

export class UploadDocumentsFromCashierActionHandler extends ActionHandlerBase<IPerformActionPayloadBase> {
    async handle(payload: IPerformActionPayloadBase): Promise<void> {
        this.services.casinofiedAnalytics.openAppRequest({
            correlationID: payload.correlationID,
            launchInfo: payload.launchInfo,
            appID: AppIdentifiers.UploadDocuments,
        });

        const geoInfo = await getCasinofiedGeoInfoParams(this.services);

        this.services.casinofiedAnalytics.appInitRequest({
            correlationID: payload.correlationID,
            applicationContext: {
                launchInfo: payload.launchInfo,
                appID: AppIdentifiers.UploadDocuments,
                productPackageToID: this.services.device.os.isMobileOS ? ProductPackageToID.FULL_CASHIER_MOBILE : ProductPackageToID.FULL_CASHIER_PC, //TODO - this product package should be clarified when we will use the old cashier or the verify id standalone
                ...getCasinofiedCommonAppContextParams(this.services),
            },
            deviceInfo: getCasinofiedDeviceInfo(this.services),
            geoInfo: geoInfo,
            userInfo: {
                userMode: 'authenticated',
                regulationTypeID: this.services.regulation.getRegulationCode(),
                token: ''
            },
            messageBrokerChannels: this.services.messageBroker.channels
        });

        return this.services.cashier.openUploadDocumentsFromCashier();
    }
}